export default __webpack_public_path__ + "static/media/instagram.28944b9a.png";